import axios from '@axios';

export default {
    namespaced: true,
    state: {
        tallas: [],
        empaques: [],
        marcas: [],
        unidades: [],
        productos: [],
        presentaciones: [],
        especificaciones: [],
        establecimiento: [],
        tipoCongelacion: [],
        procesoVA: [],
        calidades: [],
        certificaciones: [],
        tratamientos: [],
    },
    getters: {
        getTalla(state) {
            return state.tallas;
        },
        getEmpaque(state) {
            return state.empaques;
        },
        getMarcas(state) {
            return state.marcas;
        },
        getUnidades(state) {
            return state.unidades;
        },
        getProductos(state) {
            return state.productos;
        },
        getPresentaciones(state) {
            return state.presentaciones;
        },
        getEspecificaciones(state) {
            return state.especificaciones;
        },
        getEstablecimientoPG(state) {
            return state.establecimiento;
        },
        getTipoCongelacion(state) {
            return state.tipoCongelacion;
        },
        getProcesoVA(state) {
            return state.procesoVA;
        },
        getCalidad(state) {
            return state.calidades;
        },
        getCertificacion(state) {
            return state.certificaciones;
        },
        getTratamiento(state) {
            return state.tratamientos;
        },
    },
    mutations: {
        setTalla(state, tallas) {
            state.tallas = tallas;
        },
        setEmpaque(state, empaques) {
            state.empaques = empaques;
        },
        setMarcas(state, marcas) {
            state.marcas = marcas;
        },
        setUnidades(state, unidades) {
            state.unidades = unidades;
        },
        setProductos(state, productos) {
            state.productos = productos;
        },
        setPresetaciones(state, presentaciones) {
            state.presentaciones = presentaciones;
        },
        setEspecificaciones(state, especificaciones) {
            state.especificaciones = especificaciones;
        },
        setEstablecimientoPG(state, establecimiento) {
            state.establecimiento = establecimiento;
        },
        setTipoCongelacion(state, tipoCongelacion) {
            state.tipoCongelacion = tipoCongelacion;
        },
        setProcesoVA(state, procesoVA) {
            state.procesoVA = procesoVA;
        },
        setCalidad(state, calidades) {
            state.calidades = calidades;
        },
        setCertificacion(state, certificaciones) {
            state.certificaciones = certificaciones;
        },
        setTratamiento(state, tratamientos) {
            state.tratamientos = tratamientos;
        },
    },
    actions: {
        fetchTalla({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getTallaPG')
                    .then(response => {
                        commit('setTalla', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchEmpaque({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getEmpaquePG')
                    .then(response => {
                        commit('setEmpaque', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchMarca({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getMarcaPG')
                    .then(response => {
                        commit('setMarcas', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchUnidad({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getUnidad')
                    .then(response => {
                        commit('setUnidades', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchProducto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getProducto')
                    .then(response => {
                        commit('setProductos', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchPresentacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getPresentacion')
                    .then(response => {
                        commit('setPresetaciones', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchEspecificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getEspecificacionCliente', { params: data })
                    .then(response => {
                        commit('setEspecificaciones', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchEstablecimientoPG({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getEstablecimientosPG', { params: data })
                    .then(response => {
                        commit('setEstablecimientoPG', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchTipoCongelacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getTipoCongelacion')
                    .then(response => {
                        commit('setTipoCongelacion', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchProcesoVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getProcesoVA')
                    .then(response => {
                        commit('setProcesoVA', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getCalidad')
                    .then(response => {
                        commit('setCalidad', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchCertificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getCertificacion')
                    .then(response => {
                        commit('setCertificacion', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchTratamiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/produccionPG/getTratamiento')
                    .then(response => {
                        commit('setTratamiento', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
    }
};